module.exports = __webpack_public_path__ + "static/media/bg-bente.3eeac265.png";